import BaseAbility from 'umg-ember-backend/abilities/base';

export default class MlpDownloadLinkFormAbility extends BaseAbility {
  get permissions() {
    return this.permission.for('content-item');
  }
}
